// extracted by mini-css-extract-plugin
module.exports = {"automatTabs":"AutomatTabs_automatTabs__2QNAF"};